import { render, staticRenderFns } from "./RentalObjectRules.vue?vue&type=template&id=613ad58c&"
import script from "./RentalObjectRules.vue?vue&type=script&lang=js&"
export * from "./RentalObjectRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports